module.exports = __webpack_public_path__ + "static/best_payment_gateway_rates-f9319e5506a6227051288d4b5f3b8448.svg";